import type { IconProps } from './types'

export const FlagItIcon = ({ className }: IconProps) => {
  return (
    <svg
      viewBox="0 0 64 48"
      className={className}
      aria-hidden="true"
    >
      <rect width="64" height="48" rx="8" fill="#F4F5F0" />
      <path d="M0 0H21.33V48H0Z" fill="#009246" />
      <path d="M42.67 0H64V48H42.67Z" fill="#CE2B37" />
    </svg>
  )
}
